module.exports = __webpack_public_path__ + "img/product-bud.b0c65710.png";